import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAppHdProps } from './IconAppHd.types'
import * as Styled from './styles/IconAppHd.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAppHd: FC<IconAppHdProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAppHdProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAppHdProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M10.457 7.047v3.613M8.16 7.031v3.614m0-1.879h2.297m2.02.07V7.03c.91 0 1.078-.008 1.414.137.64.281.937.875.937 1.668 0 .797-.297 1.39-.937 1.664-.336.145-.5.137-1.414.137Zm5.144 11.312h1.746m-3.785-5.957v-1.625c0-.578.469-1.05 1.05-1.05H21.5v8.957c0 .578-.469 1.047-1.047 1.047h-3.82c-.582 0-1.051-.47-1.051-1.047V14.19m-2.844.841h-2.547'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M15.473 16.52H4.383a1.875 1.875 0 0 1-1.875-1.875V5.406c0-1.035.84-1.875 1.875-1.875h16.101v7.75'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAppHd
